import { ProgressSpinner } from "primereact/progressspinner";
import React from "react";

interface FileActionLoaderProps {
    className?: string;
    width?: number;
    height?: number;
    strokeWidth?: string;
}

const FileActionLoader: React.FC<FileActionLoaderProps> = (
    {
        className,
        width = 30,
        height = 30,
        strokeWidth = '6',
    }
) => {
    return (
        <div className="file_action_loader_container">
            <ProgressSpinner
                className={`file_action_loader ${className ? className : ''}`}
                style={{ width: `${width}px`, height: `${height}px` }}
                strokeWidth={strokeWidth}
                fill="transparent"
                animationDuration="1s"
            />
        </div>
    )
}

export default FileActionLoader;